import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../rootReducer";
import axios from "axios";
import { Document } from "../../../@types/document";
import axiosInstance from "../../../utils/axiosConfig";

export const createDocument = createAsyncThunk(
  "documentCreate/createDocument",
  async (documentFormData: Document, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;
      const { id: userAuthenticatedId } = state.userAuthentication?.user || {};

      const { title, category, archive, signatureProvider } = documentFormData;

      const { data } = await axiosInstance.post(`${api.baseURL}document`, {
        title,
        archive: archive?.id,
        author: userAuthenticatedId,
        category: category?.id,
        signatureProvider: signatureProvider?.id,
        sourceOrganization: state.userAuthentication.user?.sourceOrganization,
      });

      return data as Document;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
